export default __webpack_public_path__ + "static/media/uiux.5fb0c0d7.svg";